import * as React     from 'react';
import { withRouter } from 'react-router-dom';
import { Title }      from 'relevant-ui';
import './styles.scss';

const NotFoundPage: any = () => {
  return (
    <div className="dashboard">
      <Title
        title={'404'}
        subtitle={'Cette page n\'existe pas ou n\'existe plus. Nous vous prions de nous excuser pour la gêne occasionnée.'}
      />
    </div>
  );
};

export default withRouter(NotFoundPage);
